import { StoryboardFrame } from '@/features/storyboard/types/storyboard.types'
import { db, StoryboardEntity } from '@/shared/lib/db'
import { BaseLocalRepository } from '@/shared/services/repository/BaseRepository'

class StoryboardRepository extends BaseLocalRepository<StoryboardEntity> {
    constructor() {
        super(db.storyboards, 'storyboards')
    }

    async getBySceneId(projectId: string, sceneId: string): Promise<StoryboardEntity | undefined> {
        return this.table.where('[projectId+sceneId]').equals([projectId, sceneId]).first()
    }

    async getByProjectId(projectId: string): Promise<StoryboardEntity[]> {
        return this.table.where('projectId').equals(projectId).toArray()
    }

    async saveFrames(projectId: string, sceneId: string, frames: StoryboardFrame[]) {
        const existing = await this.getBySceneId(projectId, sceneId)
        
        const entity: StoryboardEntity = {
            id: existing?.id ?? crypto.randomUUID(),
            projectId,
            sceneId,
            frames,
            created_at: existing?.created_at ?? new Date(),
            updated_at: new Date()
        }
        
        await this.save(entity)
    }
}

export const storyboardRepository = new StoryboardRepository()
